import React from 'react';
import { Typography, Box } from '@mui/material';

export default function RendimientoReportes() {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4">Performance Reports - Coming Soon</Typography>
      <Typography variant="body1">This component will show performance reports with comparative metrics and export functionality.</Typography>
    </Box>
  );
}
